
import bravescared from "assets/workshops/brave.jpg";
import consent from "assets/workshops/consent.jpg";
import soulcraft from "assets/workshops/soulcraft.png";
import emotionflow from "assets/workshops/emotionflow.png";
import opening from "assets/workshops/opening.png";
import improvpartnering from "assets/workshops/improvpartnering.jpg";
import createcollective from "assets/workshops/createcollective.png";

export const workshops = [
  {
    img: createcollective,
    event:
      "Create Collective: Free Community Arts Making & Gathering",
    eventLink: "https://www.instagram.com/p/DIM98qNyYqO/",
    displayDate: "May 31, 2025",
    formatDate: "May 31, 2025",
    performer: "Violet Moon",
    style: "",
    location: "Asch Building",
    production: "Asch Building; Tadaima Home",
  },
  {
    img: improvpartnering,
    event:
      "Consent in Partnership: Honoring Choice in Improvisational Movement",
    eventLink: "https://www.instagram.com/p/DIM98qNyYqO/",
    displayDate: "May 1, 2025",
    formatDate: "May 1, 2025",
    performer: "Violet Moon",
    style: "",
    location: "Midtown Arts & Theater Center Houston",
    production: "Dance Source Houston",
  },
  {
    img: opening,
    event:
      "Opening Creativity: A Movement Exploration of Shame in Choreographic Development",
    eventLink: "https://www.instagram.com/p/DGi9DohMOYs/",
    displayDate: "March 8, 2025",
    formatDate: "March 8, 2025",
    performer: "Violet Moon",
    style: "",
    location: "MET Dance",
    production: "Houston Dance Co-Op",
  },
  {
    img: bravescared,
    event:
      "To Be Scared is To Be Brave: Connecting to the Body Through Change ",
    eventLink: "https://www.instagram.com/p/DBKMY2bJz7k/?img_index=1",
    displayDate: "October 19, 2024",
    formatDate: "October 19, 2024",
    performer: "Violet Moon",
    style: "",
    location: "Stude Park",
    production: "Houston Dance Co-Op",
  },
  {
    img: consent,
    event:
      "Consent Culture in Dance: Navigating Body Safety with Self & Others",
    eventLink: "https://www.canva.com/design/DAGTIbew0tI/FNOfoi1N_fVe3ecfV09qzQ/view",
    displayDate: "October 16, 2024",
    formatDate: "October 16, 2024",
    performer: "Violet Moon",
    style: "Abstract Portrait Paintings",
    location: "Houston MET Dance",
    production: "Dance Source Houston",
  },
  {
    img: emotionflow,
    event:
      "EmotionFlow: Somatic Movement and Feelings Reflection Group Therapy",
    eventLink: "https://www.instagram.com/p/C9N0SaFplhq/?img_index=1",
    displayDate: "July 16-August 13, 2022",
    formatDate: "August 20, 2024",
    performer: "Violet Moon",
    style: "Somatic Movement",
    location: "Virtual",
    production: "CHill Counseling",
  },
  {
    img: soulcraft,
    event: "SoulCraft: Expressive Arts Group Therapy",
    eventLink: "https://www.instagram.com/p/C3BWXVBusOB/?img_index=1",
    displayDate: "April 4-June 13, 2024",
    formatDate: "September 2, 2022",
    performer: "Violet Moon",
    style: "Expressive Arts",
    location: "Virtual",
    production: "CHill Counseling",
  },
];
